import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { RuntimeEnvironmentService } from '@app/core/runtime-environment.service';

/**
 * Prepends relative request URLs with the apiUrl of RuntimeEnvironmentService.
 */
@Injectable()
export class ApiHostInterceptorService implements HttpInterceptor {

  constructor(private runtimeEnvironmentService: RuntimeEnvironmentService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (!req.url.match(/^[a-z]+:/i)) {
      // target URL has no scheme - this is a relative URL

      req = req.clone({
        url: this.runtimeEnvironmentService.apiUrl + req.url,
      });
    }
    return next.handle(req);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/http-interceptors/api-host-interceptor.service.ts